import { hasAccessToEvent } from '@collector/sportsapi-client'
import { EventScout } from '@collector/sportsapi-client-legacy'
import { useAuth } from '@desktop/globalState/userAuth/useAuth'

// TODO: move to auth(orization) module
export function validateAssignedScouts(assignedScouts: EventScout[]): void {
  const { authInfo } = useAuth()
  if (!authInfo.value || !hasAccessToEvent(authInfo.value, assignedScouts))
    throw Error('You are not assigned to this relation')
}

export function validateRelationAccess(assignedScouts: EventScout[]): void {
  validateAssignedScouts(assignedScouts)
}
